import React from "react";
import { StandardSendForm } from "./StandardSendForm";
import { ClientReportType } from "../../../../types/ClientReportType";

export const PostSendOptionsForm = ({ report } : Readonly<{ report: ClientReportType }>) => (
    <StandardSendForm report={report} />
);